import {NgModule} from '@angular/core';
import {CoreModule} from 'features/core/core.module';
import {CP_ENTITY_PROVIDER} from './cp.entity-provider';
import {CP_TEST_PROVIDERS} from './test/cp-test-definition';

// Pages
import {CpConfigPage} from './page/cp-config-page/cp-config.page';
import {CpDashboardPage} from './page/cp-dashboard-page/cp-dashboard.page';

// Dashboard content components (children of the cp/dashboard shell route)
import {
    CpProvisionDashboardStartComponent
} from './component/protected-components/cp-provision-dashboard-start/cp-provision-dashboard-start.component';
import {
    CpProvisionRunsComponent
} from './component/protected-components/cp-provision-runs/cp-provision-runs.component';
import {
    CpProvisionRunDetailComponent
} from './component/protected-components/cp-provision-run-detail/cp-provision-run-detail.component';
import {
    CpProvisionAgentsComponent
} from './component/protected-components/cp-provision-agents/cp-provision-agents.component';
import {
    CpProvisionRunStatusFlowComponent
} from './component/protected-components/cp-provision-run-status-flow/cp-provision-run-status-flow.component';
import {
    CpRunActivationConfirmDialogComponent
} from './component/protected-components/cp-run-activation-confirm-dialog/cp-run-activation-confirm-dialog.component';
import {
    CpRunCreateDialogComponent
} from './component/protected-components/cp-run-create-dialog/cp-run-create-dialog.component';
import {
    CpProvisionSimulationComponent
} from './component/protected-components/cp-provision-simulation/cp-provision-simulation.component';
import {
    CpProvisionSimulationEntitlementsComponent
} from './component/shared/cp-provision-simulation-entitlements/cp-provision-simulation-entitlements.component';
import {
    CpProvisionSimulationProtocolComponent
} from './component/shared/cp-provision-simulation-protocol/cp-provision-simulation-protocol.component';

// Object components
import {
    CpProvisionAgentObjectComponent
} from './component/object-components/cp-provision-agent-object/cp-provision-agent-object.component';
import {
    CpProvisionAgentBaseComponent
} from './component/object-components/cp-provision-agent-object/view/base/cp-provision-agent-base.component';
import {
    CpProvisionAgentFullComponent
} from './component/object-components/cp-provision-agent-object/view/full/cp-provision-agent-full.component';
import {
    CpProvisionAgentSideComponent
} from './component/object-components/cp-provision-agent-object/view/side/cp-provision-agent-side.component';

// ProvisionAgent OBC — shared detail components per navItem (04-frontend.md §7)
import {
    CpProvisionAgentBaseDataComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-base-data/cp-provision-agent-base-data.component';
import {
    CpProvisionAgentBalanceComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-balance/cp-provision-agent-balance.component';
import {
    CpProvisionAgentAccountComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-account/cp-provision-agent-account.component';
import {
    CpProvisionAgentManualBookingDialogComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-manual-booking-dialog/cp-provision-agent-manual-booking-dialog.component';
import {
    CpProvisionAgentStatementReissueDialogComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-statement-reissue-dialog/cp-provision-agent-statement-reissue-dialog.component';
import {
    CpProvisionAgentStatementsComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-statements/cp-provision-agent-statements.component';
import {
    CpProvisionAgentTransferDialogComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-transfer-dialog/cp-provision-agent-transfer-dialog.component';
import {
    CpProvisionAgentPayoutsComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-payouts/cp-provision-agent-payouts.component';
import {
    CpProvisionAgentGroupsComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-groups/cp-provision-agent-groups.component';
import {
    CpProvisionAgentReserveCoverageComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-reserve-coverage/cp-provision-agent-reserve-coverage.component';
import {
    CpProvisionAgentContractAgentsComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-contract-agents/cp-provision-agent-contract-agents.component';
import {
    CpProvisionAgentChangeDialogComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-change-dialog/cp-provision-agent-change-dialog.component';
import {
    CpProvisionAgentAmountOverwriteDialogComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-amount-overwrite-dialog/cp-provision-agent-amount-overwrite-dialog.component';
import {
    CpProvisionAgentManualRateDialogComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-manual-rate-dialog/cp-provision-agent-manual-rate-dialog.component';
import {
    CpProvisionAgentKpiComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-kpi/cp-provision-agent-kpi.component';
import {
    CpProvisionAgentConfigurationComponent
} from './component/object-components/cp-provision-agent-object/shared/cp-provision-agent-configuration/cp-provision-agent-configuration.component';

// ProvisionContractAgent object component — Review Workbench right pane (requirement.md §4);
// navItems: Basisdaten | Beträge | Haftung | Vertrag | Buchungen | Storno
import {
    CpProvisionContractAgentObjectComponent
} from './component/object-components/cp-provision-contract-agent-object/cp-provision-contract-agent-object.component';
import {
    CpProvisionContractAgentBaseComponent
} from './component/object-components/cp-provision-contract-agent-object/view/base/cp-provision-contract-agent-base.component';
import {
    CpProvisionContractAgentFullComponent
} from './component/object-components/cp-provision-contract-agent-object/view/full/cp-provision-contract-agent-full.component';
import {
    CpProvisionContractAgentSideComponent
} from './component/object-components/cp-provision-contract-agent-object/view/side/cp-provision-contract-agent-side.component';
import {
    CpProvisionObjectDataComponent
} from './component/object-components/cp-provision-contract-agent-object/shared/cp-provision-object-data/cp-provision-object-data.component';
import {
    CpProvisionContractAgentBaseDataComponent
} from './component/object-components/cp-provision-contract-agent-object/shared/cp-provision-contract-agent-base-data/cp-provision-contract-agent-base-data.component';
import {
    CpProvisionContractAgentAmountsComponent
} from './component/object-components/cp-provision-contract-agent-object/shared/cp-provision-contract-agent-amounts/cp-provision-contract-agent-amounts.component';
import {
    CpProvisionContractAgentLiabilityComponent
} from './component/object-components/cp-provision-contract-agent-object/shared/cp-provision-contract-agent-liability/cp-provision-contract-agent-liability.component';
import {
    CpProvisionContractAgentContractComponent
} from './component/object-components/cp-provision-contract-agent-object/shared/cp-provision-contract-agent-contract/cp-provision-contract-agent-contract.component';
import {
    CpProvisionContractAgentTransactionsComponent
} from './component/object-components/cp-provision-contract-agent-object/shared/cp-provision-contract-agent-transactions/cp-provision-contract-agent-transactions.component';
import {
    CpProvisionContractAgentCancellationComponent
} from './component/object-components/cp-provision-contract-agent-object/shared/cp-provision-contract-agent-cancellation/cp-provision-contract-agent-cancellation.component';

// ProvisionContract object component — A-5 withdrawn, the OBC for cp.ProvisionContract IS in scope
// (requirement.md §7, capability-matrix.md H2)
import {
    CpProvisionContractObjectComponent
} from './component/object-components/cp-provision-contract-object/cp-provision-contract-object.component';
import {
    CpProvisionContractBaseComponent
} from './component/object-components/cp-provision-contract-object/view/base/cp-provision-contract-base.component';
import {
    CpProvisionContractFullComponent
} from './component/object-components/cp-provision-contract-object/view/full/cp-provision-contract-full.component';
import {
    CpProvisionContractSideComponent
} from './component/object-components/cp-provision-contract-object/view/side/cp-provision-contract-side.component';
import {
    CpProvisionContractBaseDataComponent
} from './component/object-components/cp-provision-contract-object/shared/cp-provision-contract-base-data/cp-provision-contract-base-data.component';
import {
    CpProvisionContractCalculationComponent
} from './component/object-components/cp-provision-contract-object/shared/cp-provision-contract-calculation/cp-provision-contract-calculation.component';
import {
    CpProvisionContractContractAgentsComponent
} from './component/object-components/cp-provision-contract-object/shared/cp-provision-contract-contract-agents/cp-provision-contract-contract-agents.component';
import {
    CpProvisionContractCancellationComponent
} from './component/object-components/cp-provision-contract-object/shared/cp-provision-contract-cancellation/cp-provision-contract-cancellation.component';

// Top-down Anlage-/Anpassungs-Wizards (FD-2 — frontend components, no uf) —
// requirement.md §10, capability-matrix.md B10/FD-2a Group B
import {
    CpProvisionContractCreateWizardComponent
} from './component/protected-components/cp-provision-contract-create-wizard/cp-provision-contract-create-wizard.component';
import {
    CpProvisionContractAdjustWizardComponent
} from './component/protected-components/cp-provision-contract-adjust-wizard/cp-provision-contract-adjust-wizard.component';

// ProvisionType OBC (CONFIG-003 Complex Configuration Entity Rule) —
// root OBC + view/base|full|side + shared detail components (PAT §L.2)
import {
    CpProvisionTypeObjectComponent
} from './component/object-components/cp-provision-type-object/cp-provision-type-object.component';
import {
    CpProvisionTypeBaseComponent
} from './component/object-components/cp-provision-type-object/view/base/cp-provision-type-base.component';
import {
    CpProvisionTypeFullComponent
} from './component/object-components/cp-provision-type-object/view/full/cp-provision-type-full.component';
import {
    CpProvisionTypeSideComponent
} from './component/object-components/cp-provision-type-object/view/side/cp-provision-type-side.component';
import {
    CpProvisionTypeBaseDataComponent
} from './component/object-components/cp-provision-type-object/shared/cp-provision-type-base-data/cp-provision-type-base-data.component';
import {
    CpProvisionTypeChildTableComponent
} from './component/object-components/cp-provision-type-object/shared/cp-provision-type-child-table/cp-provision-type-child-table.component';
import {
    CpProvisionTypeMatrixComponent
} from './component/object-components/cp-provision-type-object/shared/cp-provision-type-matrix/cp-provision-type-matrix.component';
import {
    CpProvisionTypeContractEventComponent
} from './component/object-components/cp-provision-type-object/shared/cp-provision-type-contract-event/cp-provision-type-contract-event.component';
import {
    CpProvisionTypeMatrixAssignmentComponent
} from './component/object-components/cp-provision-type-object/shared/cp-provision-type-matrix-assignment/cp-provision-type-matrix-assignment.component';
import {
    CpProvisionTypeComponentEligibilityComponent
} from './component/object-components/cp-provision-type-object/shared/cp-provision-type-component-eligibility/cp-provision-type-component-eligibility.component';
import {
    CpProvisionTypeCalculatedAgentComponent
} from './component/object-components/cp-provision-type-object/shared/cp-provision-type-calculated-agent/cp-provision-type-calculated-agent.component';
import {
    CpProvisionTypeConditionSetComponent
} from './component/object-components/cp-provision-type-object/shared/cp-provision-type-condition-set/cp-provision-type-condition-set.component';
import {
    CpProvisionAssignmentConditionPreviewComponent
} from './component/object-components/cp-provision-type-object/shared/cp-provision-assignment-condition-preview/cp-provision-assignment-condition-preview.component';

// ProvisionTypeMatrix object component — opened by the inheritance-chain chip of the Beratersicht
// in the LEFT drawer (uiMode = 'side'); one navItem: Übersicht (Kopfdaten + Matrixzeilen)
import {
    CpProvisionTypeMatrixObjectComponent
} from './component/object-components/cp-provision-type-matrix-object/cp-provision-type-matrix-object.component';
import {
    CpProvisionTypeMatrixBaseComponent
} from './component/object-components/cp-provision-type-matrix-object/view/base/cp-provision-type-matrix-base.component';
import {
    CpProvisionTypeMatrixFullComponent
} from './component/object-components/cp-provision-type-matrix-object/view/full/cp-provision-type-matrix-full.component';
import {
    CpProvisionTypeMatrixSideComponent
} from './component/object-components/cp-provision-type-matrix-object/view/side/cp-provision-type-matrix-side.component';
import {
    CpProvisionTypeMatrixOverviewComponent
} from './component/object-components/cp-provision-type-matrix-object/shared/cp-provision-type-matrix-overview/cp-provision-type-matrix-overview.component';

// Shared detail components (reusable across pages/object components)
import {
    CpConfigCheckPanelComponent
} from './component/shared/cp-config-check-panel/cp-config-check-panel.component';
import {
    CpFormFieldOutputOriginComponent
} from './component/shared/cp-form-field-output-origin/cp-form-field-output-origin.component';
import {
    CpFormFieldOutputFactorComponent
} from './component/shared/cp-form-field-output-factor/cp-form-field-output-factor.component';
import {
    CpProvisionCalculatedAgentResetDialogComponent
} from './component/shared/cp-provision-calculated-agent-reset-dialog/cp-provision-calculated-agent-reset-dialog.component';
// Read-only review panes of the run detail (FE-A)
import {CpRunDetailAgentListComponent} from './component/shared/cp-run-detail-agent-list/cp-run-detail-agent-list.component';
import {CpRunDetailMessageComponent} from './component/shared/cp-run-detail-message/cp-run-detail-message.component';
import {
    CpRunDetailContractRunComponent
} from './component/shared/cp-run-detail-contract-run/cp-run-detail-contract-run.component';
import {CpRunDetailTotalsComponent} from './component/shared/cp-run-detail-totals/cp-run-detail-totals.component';
import {
    CpRunDetailContractLinkComponent
} from './component/shared/cp-run-detail-contract-link/cp-run-detail-contract-link.component';

/**
 * Feature module cp (provision outgoing).
 *
 * Module trio per 04-frontend.md §1 and PAT §N.2:
 *   cp.module.ts           — declarations + CP_ENTITY_PROVIDER + CP_TEST_PROVIDERS
 *   cp.route.ts            — CpSubRoutes()
 *   cp.entity-provider.ts  — CP_ENTITY_PROVIDER (all 28 cp.* aliases)
 *
 * Wired into the feature-prov group (feature-prov.module.ts / feature-prov.routing.module.ts);
 * nothing needs to change on the shell itself, feature-prov is already wired lazily.
 *
 * All components are NgModule components (`standalone: false`) with separate
 * .ts/.html/.scss files. Object components are additionally registered in CP_ENTITY_PROVIDER
 * (objectComponent[]) so the framework resolves them for the
 * click-to-object-page chain.
 *
 * DOCUMENTED DEVIATION — enum folder location (befund 15, deliberately NOT changed): CLAUDE.md
 * and 04-frontend.md §1 explicitly prescribe the top-level `enum/` folder for a module's enums,
 * not the `model/dto/enum/` location `fe_core_standards` names as the default. This module's
 * enums live in `cp/enum/`, mirroring the reference module bm
 * (`features/feature-bm/bm/enum/`), which uses the identical top-level layout. Per the user's
 * directive to follow the already-implemented, referenced components/modules when a skill rule and
 * the reference module disagree, `cp/enum/` stands as-is.
 *
 * DOCUMENTED DEVIATION — enum TYPE NAMES carry no `Enum` suffix (same directive, same reason).
 * `fe_core_dto` rule EN3 asks for `<EnumName>Enum`; this module names its enums after the backend
 * enum they mirror, and the backend spells the suffix only where it disambiguates. The count
 * decides it: of the module's enum types exactly ONE carries the suffix — `ProvisionAgentRoleEnum`,
 * and it carries it because the backend type it mirrors is spelled that way. Every other one is
 * `ProvisionAccountKind`, `ProvisionLiabilityStatus`, `ProvisionConfigurationAxis` and so on.
 * Renaming the majority to satisfy EN3 would break the one property that makes a position-based
 * mirror auditable: that the TypeScript type is called what the Java enum is called, so a reviewer
 * can put the two files side by side and compare ordinal for ordinal. New enums in this module
 * follow the module, not EN3 — the suffix appears only when the backend type has it. File names
 * (`<name>.enum.ts`) and the implicit-member / UPPER_SNAKE rules are followed without exception.
 */
@NgModule({
    declarations: [
        // Pages
        CpConfigPage,
        CpDashboardPage,

        // Dashboard content components
        CpProvisionDashboardStartComponent,
        CpProvisionRunsComponent,
        CpProvisionRunDetailComponent,
        CpProvisionAgentsComponent,
        CpProvisionSimulationComponent,

        // Step bar of the run detail (04 §5.1) - rendered inside CpProvisionRunDetailComponent
        CpProvisionRunStatusFlowComponent,
        // Activation confirmation (step bar) and "Neuen Provisionslauf anlegen" (run list)
        CpRunActivationConfirmDialogComponent,
        CpRunCreateDialogComponent,

        // The two halves of a simulation answer. Under component/shared/ because they are the
        // reusable display of ONE `ProvisionSimulationResultDto` and are meant to be renderable
        // from a second host later (the Beratersicht, a contract object) without moving a file.
        CpProvisionSimulationEntitlementsComponent,
        CpProvisionSimulationProtocolComponent,

        // ProvisionAgent object component (04 §7) — root OBC + view/base|full|side +
        // the shared detail components per navItem (PAT §L.2).
        CpProvisionAgentObjectComponent,
        CpProvisionAgentBaseComponent,
        CpProvisionAgentFullComponent,
        CpProvisionAgentSideComponent,

        CpProvisionAgentBaseDataComponent,
        CpProvisionAgentBalanceComponent,
        CpProvisionAgentAccountComponent,
        CpProvisionAgentManualBookingDialogComponent,
        CpProvisionAgentStatementReissueDialogComponent,
        CpProvisionAgentStatementsComponent,
        CpProvisionAgentTransferDialogComponent,
        CpProvisionAgentPayoutsComponent,
        CpProvisionAgentGroupsComponent,
        CpProvisionAgentReserveCoverageComponent,
        CpProvisionAgentContractAgentsComponent,
        CpProvisionAgentChangeDialogComponent,
        CpProvisionAgentAmountOverwriteDialogComponent,
        CpProvisionAgentManualRateDialogComponent,
        CpProvisionAgentKpiComponent,
        CpProvisionAgentConfigurationComponent,

        // ProvisionContractAgent object component — Review Workbench right pane (requirement.md §4)
        CpProvisionContractAgentObjectComponent,
        CpProvisionContractAgentBaseComponent,
        CpProvisionContractAgentFullComponent,
        CpProvisionContractAgentSideComponent,

        // Shared between the ProvisionContractAgent and the ProvisionContract OBC trees —
        // declared exactly once
        CpProvisionObjectDataComponent,

        CpProvisionContractAgentBaseDataComponent,
        CpProvisionContractAgentAmountsComponent,
        CpProvisionContractAgentLiabilityComponent,
        CpProvisionContractAgentContractComponent,
        CpProvisionContractAgentTransactionsComponent,
        CpProvisionContractAgentCancellationComponent,

        // ProvisionContract object component — A-5 withdrawn (requirement.md §7)
        CpProvisionContractObjectComponent,
        CpProvisionContractBaseComponent,
        CpProvisionContractFullComponent,
        CpProvisionContractSideComponent,

        CpProvisionContractBaseDataComponent,
        CpProvisionContractCalculationComponent,
        CpProvisionContractContractAgentsComponent,
        CpProvisionContractCancellationComponent,

        // Top-down Anlage-/Anpassungs-Wizards (FD-2, capability-matrix.md B10)
        CpProvisionContractCreateWizardComponent,
        CpProvisionContractAdjustWizardComponent,

        // ProvisionType object component — MANDATORY under the Complex Configuration Entity Rule
        // (CONFIG-003/CONFIG-015): cp.ProvisionType owns twelve same-module configuration children,
        // so the config page only lists it and the children live behind THIS component's left
        // navigation. Reference for the identical situation: bd.module.ts:240
        // (DunningTypeObjectComponent for bd.DunningType).
        CpProvisionTypeObjectComponent,
        CpProvisionTypeBaseComponent,
        CpProvisionTypeFullComponent,
        CpProvisionTypeSideComponent,

        CpProvisionTypeBaseDataComponent,
        CpProvisionTypeChildTableComponent,
        CpProvisionTypeContractEventComponent,
        CpProvisionTypeMatrixComponent,
        CpProvisionTypeMatrixAssignmentComponent,
        CpProvisionTypeComponentEligibilityComponent,
        CpProvisionTypeCalculatedAgentComponent,
        CpProvisionTypeConditionSetComponent,
        CpProvisionAssignmentConditionPreviewComponent,

        // ProvisionTypeMatrix object component — the inheritance-chain chip of the Beratersicht
        // opens cp.ProvisionTypeMatrix in the left drawer; without this OBC the click landed in
        // the generic editing form
        CpProvisionTypeMatrixObjectComponent,
        CpProvisionTypeMatrixBaseComponent,
        CpProvisionTypeMatrixFullComponent,
        CpProvisionTypeMatrixSideComponent,
        CpProvisionTypeMatrixOverviewComponent,

        // Shared detail components — check report panel of the navItem "Konfigurationsprüfung"
        // of the ProvisionType object page (04 §6, child 11);
        // deliberately under component/shared/, so it can later also be embedded in the
        // ProvisionAgent OBC or in the dashboard.
        CpConfigCheckPanelComponent,

        // Output field components of the cp display vocabulary (design gate auflage H5) —
        // MvsFormFieldOutputBaseComponent subclasses, used by SELECTOR. Deliberately NOT registered
        // via an ADDITIONAL_OUTPUT_FIELDS provider: that token is NON-multi and CcModule already
        // provides it, while its only consumer MvsFormFieldService is providedIn 'root' and would
        // never read a lazy module's map anyway — a second provider here would buy nothing and
        // shadow cc's struct/array/list controls inside cp's injector scope. Reasoning in full in
        // the javadoc of CpFormFieldOutputOriginComponent.
        CpFormFieldOutputOriginComponent,
        CpFormFieldOutputFactorComponent,

        // Guided reset "Berechnete Vermittler neu ermitteln" on ONE cp.ProvisionContract event row
        // (§3.6, FD-7, D-5). Under component/shared/ because it has TWO hosts: the CR-033 worklist
        // of the check panel above and the "Ereignisse" tab of the run detail.
        CpProvisionCalculatedAgentResetDialogComponent,

        // Read-only review panes of the run detail tabs (FE-A): no form, no save, no delete.
        CpRunDetailAgentListComponent,
        CpRunDetailMessageComponent,
        CpRunDetailContractRunComponent,
        CpRunDetailTotalsComponent,
        CpRunDetailContractLinkComponent,
    ],
    exports: [
        CpConfigPage,
        CpDashboardPage,

        CpProvisionDashboardStartComponent,
        CpProvisionRunsComponent,
        CpProvisionRunDetailComponent,
        CpProvisionAgentsComponent,
        CpProvisionSimulationComponent,

        CpProvisionRunStatusFlowComponent,
        CpRunActivationConfirmDialogComponent,
        CpRunCreateDialogComponent,

        CpProvisionSimulationEntitlementsComponent,
        CpProvisionSimulationProtocolComponent,

        CpProvisionAgentObjectComponent,
        CpProvisionAgentBaseComponent,
        CpProvisionAgentFullComponent,
        CpProvisionAgentSideComponent,

        CpProvisionAgentBaseDataComponent,
        CpProvisionAgentBalanceComponent,
        CpProvisionAgentAccountComponent,
        CpProvisionAgentManualBookingDialogComponent,
        CpProvisionAgentStatementReissueDialogComponent,
        CpProvisionAgentStatementsComponent,
        CpProvisionAgentTransferDialogComponent,
        CpProvisionAgentPayoutsComponent,
        CpProvisionAgentGroupsComponent,
        CpProvisionAgentReserveCoverageComponent,
        CpProvisionAgentContractAgentsComponent,
        CpProvisionAgentChangeDialogComponent,
        CpProvisionAgentAmountOverwriteDialogComponent,
        CpProvisionAgentManualRateDialogComponent,
        CpProvisionAgentConfigurationComponent,

        // ProvisionContractAgent OBC root — resolved by the framework for the
        // click-to-object-page chain (04-frontend.md §7 pattern)
        CpProvisionContractAgentObjectComponent,

        // ProvisionContract OBC root — same reason (A-5 withdrawn)
        CpProvisionContractObjectComponent,

        // Wizards — embedded as dialogs from outside this module (requirement.md §10)
        CpProvisionContractCreateWizardComponent,
        CpProvisionContractAdjustWizardComponent,

        CpProvisionTypeObjectComponent,
        CpProvisionTypeBaseComponent,
        CpProvisionTypeFullComponent,
        CpProvisionTypeSideComponent,

        CpProvisionTypeBaseDataComponent,
        CpProvisionTypeChildTableComponent,
        CpProvisionTypeContractEventComponent,
        CpProvisionTypeMatrixComponent,
        CpProvisionTypeMatrixAssignmentComponent,
        CpProvisionTypeComponentEligibilityComponent,
        CpProvisionTypeCalculatedAgentComponent,
        CpProvisionTypeConditionSetComponent,
        CpProvisionAssignmentConditionPreviewComponent,

        // ProvisionTypeMatrix OBC root — resolved by the framework for the click-to-object chain
        // of the inheritance-chain chip (same reason as the ProvisionContractAgent root above)
        CpProvisionTypeMatrixObjectComponent,

        CpConfigCheckPanelComponent,
        CpProvisionCalculatedAgentResetDialogComponent,
        CpFormFieldOutputOriginComponent,
        CpFormFieldOutputFactorComponent,
    ],
    imports: [
        CoreModule,
    ],
    providers: [
        CP_TEST_PROVIDERS,
        CP_ENTITY_PROVIDER,
    ]
})
export class CpModule {
}
